/*
 * HC FAQ category nav.
 *
 * Ported from design/round-3/js/pages/faq.js (mount). Every nav link is a real
 * anchor to a real id, so the page works with this file blocked: the script
 * only adds the smooth scroll and the active highlight.
 *
 * Why rects rather than IntersectionObserver: the accordion panels animate
 * open and closed, so group offsets move while a transition is in flight.
 * Reading rects on scroll, on resize, and again once a row settles
 * (`hc:accordion`) stays correct through the animation.
 *
 * Instances are registered per [data-hc-faq] root, so a Theme Editor section
 * reload re-registers rather than double-binding, and one set of window
 * listeners serves them all.
 */
(function () {
  'use strict';

  var instances = [];
  var frame = 0;
  var bound = false;

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function setActive(instance, handle) {
    instance.links.forEach(function (link) {
      var on = link.getAttribute('data-hc-faq-link') === handle;
      link.classList.toggle('is-active', on);
      if (on) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  /* The line the active group is measured against: just under the sticky
     header, with a little slack so a group title that is level with the
     header still counts as current. */
  function spyLine() {
    var header = document.querySelector('.section-header, .hc-header, header');
    var height = header ? header.getBoundingClientRect().height : 0;
    return Math.max(96, Math.round(height) + 24);
  }

  function computeActive() {
    frame = 0;
    var line = spyLine();
    instances.forEach(function (instance) {
      if (!instance.root.isConnected) return;
      var current = instance.groups[0];
      instance.groups.forEach(function (group) {
        if (group.getBoundingClientRect().top <= line) current = group;
      });
      if (current) setActive(instance, current.getAttribute('data-hc-faq-group'));
    });
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(computeActive);
  }

  function bindWindow() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    /* `toggle` does not bubble, so listen in the capture phase. hc:accordion
       bubbles once an eased row has settled, which is the height to measure. */
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('hc:accordion', schedule, true);
  }

  function register(root) {
    var links = all('[data-hc-faq-link]', root);
    var groups = all('[data-hc-faq-group]', root);
    if (!links.length || !groups.length) return;

    instances = instances.filter(function (instance) {
      return instance.root !== root && instance.root.isConnected;
    });

    var instance = { root: root, links: links, groups: groups };
    instances.push(instance);

    links.forEach(function (link) {
      if (link.hcFaqBound) return;
      link.hcFaqBound = true;
      link.addEventListener('click', function (event) {
        var handle = link.getAttribute('data-hc-faq-link');
        var target = root.querySelector('[data-hc-faq-group="' + handle + '"]');
        if (!target) return;
        event.preventDefault();
        setActive(instance, handle);
        try {
          target.scrollIntoView({
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start'
          });
        } catch (error) {
          target.scrollIntoView();
        }
        /* Keep the keyboard where the reader is looking. */
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });

    bindWindow();
    schedule();
  }

  function init(scope) {
    all('[data-hc-faq]', scope || document).forEach(register);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
